import React from 'react'
import styled from 'styled-components';
import { numberToWords } from '../utils/numberToWords';
import { numberToCurrency } from '../utils/numberToCurrency';
import { mobile } from '../responsive';

const Container = styled.div`
    
    padding: 10px 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    

`
/*const Header = styled.h1`
    text-decoration: underline;
    text-align: center;
`
*/

const Wrapper = styled.div`
    width: 90%;
    font-size: 20px;
    ${mobile({
        width: '100%',
        fontSize: '13px'
    })}
`

const SubWrapper = styled.div`
    border: 1px solid gray;
    border-radius: 5px;
    margin: 20px 0;
    padding: 5px;
`

const SubHeader = styled.h1`
    font-weight: 300;
    font-size: 20px;
    text-decoration: underline;
    text-underline-offset: 4px;
    text-align: center;

`
const PVDateAndNumber = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    ${mobile({
        flexWrap: 'wrap',
        justifyContent: 'left'
    })}
    
`

const PVDate = styled.div`
    flex: 1;
    display: flex;
    place-items: center;
    margin: 10px;

    ${mobile({
        margin: '5px 10px'
    })}

`
const PVNumber = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 10px;

    ${mobile({
        margin: '5px 10px'
    })}

`

const PVNumberVal = styled.div`
    border-width: 2px 2px 2px 0px;
    /*border-style: dotted;*/
    padding: 5px;
    flex: 0.5;
    display: flex;
    justify-content: flex-end;

    ${mobile({
        justifyContent: 'left'
    })}
    
`

const PVRow = styled.div`
    display: flex;
    
    margin: 10px;
`

const TitleColumn = styled.div`
    border-width: 2px 2px 2px 2px;
    /*border-style: dotted;*/
    flex: 1;
    padding: 5px;
    font-weight: bold;

    display: flex;
    justify-content: ${props => props.align ? props.align : 'left'};
    
    ${mobile({
        justifyContent: 'left'
    })}

`
const DetailColumn = styled.div`
    border-width: 2px 2px 2px 0px;
    /*border-style: dotted;*/
    padding: 5px;
    flex: 3;
`

const DescContainer = styled.div`
    margin: 10px 10px 0 10px;
    border: 1px solid gray;
    border-radius: 5px 5px 0 5px;
`

const DescDetails = styled.div`
    /*display: flex;*/
    display: grid;
    grid-template-columns: 10% 60% 30%;
    border-top: ${props => props.borderTop ? props.borderTop : '1px solid gray'};
   
   
`

const SerialNoCol = styled.div`
    /*border: 1px solid gray;
    border-radius: 5px 0 0 5px;
    flex: 1;*/
    padding: 5px;
    ${props => props.fontWeight ? `font-weight: ${props.fontWeight};` : ''}
`

const DescCol = styled.div`
    border-style: solid;
    border-width: 0 1px; 
    border-color: gray;
    padding: 5px;
    /*flex: 6;*/
    ${ props => props.fontWeight ? `font-weight: ${props.fontWeight};` : ''}

   
`

const AmountCol = styled.div`
    /*border: 1px solid gray;
    border-radius: 0 5px 0 0;
    flex: 2;*/
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 5px;
    ${props => props.fontWeight ? `font-weight: ${props.fontWeight};` : ''}

    
`

const DescSummary = styled.div`
    display: grid;
    grid-template-columns: calc(70% - 2px) calc(30% + 2px);
    align-items: center;
    
    margin: 0 10px 10px 10px;
    
    
`

const TotalTitle = styled.div`
    
`

const TotalAmount = styled.div`
    
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-width: 0 1px 1px 1px;
    border-style: solid;
    border-color: gray;
    border-radius: 0 0 5px 5px;
    font-weight: bold;
    padding: 5px;

`

const ProjectCountRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
`

const PaymentVoucher = ({voucher}) => {
    console.log(voucher);

    
    
    return (
        <Container>
            <Wrapper>
                <SubHeader>Mega Plaza Payment Voucher for {voucher.payee}</SubHeader>
                
                <SubWrapper>
                <PVDateAndNumber>
                    <PVDate>
                    
                            <TitleColumn>
                                Date:
                            </TitleColumn>
                            <DetailColumn>
                                {voucher.voucherDateStr}
                            </DetailColumn>
                        
                    </PVDate>
                    <PVNumber>
                        
                            <TitleColumn align='right'>
                                Voucher Number:
                            </TitleColumn>
                            <PVNumberVal>
                                {voucher.voucherNo}
                            </PVNumberVal>
                        
                    
                    </PVNumber>
                </PVDateAndNumber>
                <PVRow>
                    <TitleColumn>
                        Department:
                    </TitleColumn>
                    <DetailColumn>
                        {voucher.dept}
                    </DetailColumn>
                </PVRow>
                <PVRow>
                    <TitleColumn>
                        Section:
                    </TitleColumn>
                    <DetailColumn>
                        {voucher.section}
                    </DetailColumn>
                </PVRow>
                <PVRow>
                    <TitleColumn>
                        Location:
                    </TitleColumn>
                    <DetailColumn>
                        {voucher.location}
                    </DetailColumn>
                </PVRow>
                <PVRow>
                    <TitleColumn>
                        Project:
                    </TitleColumn>
                    <DetailColumn>
                        {voucher.project}
                    </DetailColumn>
                </PVRow>
                <PVRow>
                    <TitleColumn>
                        Payee:
                    </TitleColumn>
                    <DetailColumn>
                        {voucher.payee}
                    </DetailColumn>
                </PVRow>
                <PVRow>
                    <TitleColumn>
                        Account Details:
                    </TitleColumn>
                    <DetailColumn>
                        {voucher.bank}  {voucher.acctno}
                    </DetailColumn>
                </PVRow>
                </SubWrapper>
                <SubWrapper>
                <DescContainer>
                    <DescDetails borderTop='none'>
                        <SerialNoCol fontWeight = 'bold'>
                            S/No
                        </SerialNoCol>
                        <DescCol fontWeight = 'bold'>
                            Item Description
                        </DescCol>
                        <AmountCol fontWeight = 'bold'>
                            Item Amount
                        </AmountCol>
                    </DescDetails>
                    {voucher.itemDetails?.map((item, index) => (
                        <DescDetails>
                        <SerialNoCol>
                            {index + 1}
                        </SerialNoCol>
                        <DescCol>
                            {item.itemdesc}
                        </DescCol>
                        <AmountCol>
                            {numberToCurrency(item.itemamount, true)}
                        </AmountCol>
                        </DescDetails>
                    ))}
                    
                </DescContainer>
                <DescSummary>
                        <TotalTitle>
                            
                        </TotalTitle>
                        
                        <TotalAmount>
                            {numberToCurrency(voucher.totalAmount, true)}
                        </TotalAmount>
                    </DescSummary>
                </SubWrapper>
                <SubWrapper>
                <PVRow>
                    <TitleColumn>
                        Amount In Words:
                    </TitleColumn>
                    <DetailColumn>
                        {numberToWords(voucher.totalAmount)}
                    </DetailColumn>
                </PVRow>
                
                <PVRow>
                    <TitleColumn>
                        Mode Of Payment:
                    </TitleColumn>
                    <DetailColumn>
                        {voucher.paymode}
                    </DetailColumn>
                </PVRow>

                <PVRow>
                    <TitleColumn>
                        Prepared By:
                    </TitleColumn>
                    <DetailColumn>
                        
                    </DetailColumn>
                </PVRow>

                <PVRow>
                    <TitleColumn>
                        Authorized By:
                    </TitleColumn>
                    <DetailColumn>
                        
                    </DetailColumn>
                </PVRow>

                <PVRow>
                    <TitleColumn>
                        Approved By:
                    </TitleColumn>
                    <DetailColumn>
                        
                    </DetailColumn>
                </PVRow>
                <PVRow>
                    <TitleColumn>
                        Received By:
                    </TitleColumn>
                    <DetailColumn>
                        
                    </DetailColumn>
                </PVRow>
                <PVRow>
                    <TitleColumn>
                        Cashier / DOP:
                    </TitleColumn>
                    <DetailColumn>
                        
                    </DetailColumn>
                </PVRow>
                <PVRow>
                    <TitleColumn>
                        ACC HOD:
                    </TitleColumn>
                    <DetailColumn>
                        
                    </DetailColumn>
                </PVRow>
                </SubWrapper>
                {voucher.projectCount && voucher.projectCount > 1 && 
                <ProjectCountRow>
                    {voucher.projectVSNo} of {voucher.projectCount}
                </ProjectCountRow>}
            </Wrapper>
            
        </Container>
    )
}

export default PaymentVoucher
